import Reveal from '@/components/base/Reveal';
import SectionLabel from '@/components/base/SectionLabel';
import { occasions } from '../data';

export default function Occasions() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="mx-auto max-w-2xl text-center">
          <SectionLabel align="center">For Every Celebration</SectionLabel>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl leading-[1.12] font-medium text-foreground-950">
            For Every Occasion That Matters
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {occasions.map((item, i) => (
            <Reveal key={item.title} delay={i * 90}>
              <a href="#contact" className="group block">
                <div className="img-zoom rounded-lg overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} — traditional Indian clothing and textiles`}
                    className="h-72 w-full object-cover object-top"
                  />
                </div>
                <div className="mt-5 flex items-center justify-between">
                  <h3 className="font-heading text-2xl font-semibold text-foreground-950">{item.title}</h3>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-50 text-primary-600 transition-all group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
                  </span>
                </div>
                <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{item.subtitle}</p>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10 text-center">
          <a
            href="#collections"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            Explore the Collection
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}